import { render, staticRenderFns } from "./shiftsRoster.vue?vue&type=template&id=3492e65c&"
import script from "./shiftsRoster.vue?vue&type=script&lang=js&"
export * from "./shiftsRoster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports